import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/exam/question_right.png';
import _imports_1 from '../../assets/img/exam/question_none.png';
import _imports_2 from '../../assets/img/exam/question_left.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-388b652f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "EndAnswer"
};
var _hoisted_2 = {
  key: 0
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "1",
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_4 = [_hoisted_3];
var _hoisted_5 = {
  key: 1
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "2",
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_7 = [_hoisted_6];
var _hoisted_8 = {
  key: 2
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "4",
    src: _imports_2,
    alt: ""
  }, null, -1);
});

var _hoisted_10 = [_hoisted_9];
var _hoisted_11 = {
  class: "disabled-text"
};
var _hoisted_12 = {
  key: 0
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_14 = [_hoisted_13];
var _hoisted_15 = {
  key: 1
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});

var _hoisted_17 = [_hoisted_16];
var _hoisted_18 = {
  key: 2
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_20 = [_hoisted_19];
var _hoisted_21 = {
  class: "disabled-text"
};
var _hoisted_22 = {
  key: 0,
  class: "disabled-box"
};
var _hoisted_23 = {
  key: 0
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_25 = [_hoisted_24];
var _hoisted_26 = {
  key: 1
};

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});

var _hoisted_28 = [_hoisted_27];
var _hoisted_29 = {
  key: 2
};

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_31 = [_hoisted_30];

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "disabled-text"
  }, " 对 ", -1);
});

var _hoisted_33 = {
  key: 1,
  class: "disabled-box"
};
var _hoisted_34 = {
  key: 0
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_36 = [_hoisted_35];
var _hoisted_37 = {
  key: 1
};

var _hoisted_38 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});

var _hoisted_39 = [_hoisted_38];
var _hoisted_40 = {
  key: 2
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_42 = [_hoisted_41];

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "disabled-text"
  }, " 错 ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.type == 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.options, function (itemChildren, indexChildren) {
    return _openBlock(), _createElementBlock("div", {
      key: itemChildren.id,
      class: "disabled-box"
    }, [_ctx.answer == indexChildren + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), _ctx.answer != indexChildren + 1 && _ctx.reply != indexChildren + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), _ctx.reply == indexChildren + 1 && _ctx.reply != _ctx.answer ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.alphabet[indexChildren]) + "." + _toDisplayString(_ctx.options[indexChildren].answerName), 1)]);
  }), 128)) : _createCommentVNode("", true), _ctx.type == 2 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList(_ctx.options, function (itemChildren, indexChildren) {
    return _openBlock(), _createElementBlock("div", {
      key: itemChildren.id,
      class: "disabled-box"
    }, [_ctx.answer.split(',').every(function (item) {
      return _ctx.reply.split(',').includes(item);
    }) && _ctx.answer.split(',').includes(String(indexChildren + 1)) && _ctx.reply.split(',').includes(String(indexChildren + 1)) ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)) : _ctx.answer.split(',').includes(String(indexChildren + 1)) || _ctx.answer.split(',').includes(String(indexChildren + 1)) && !_ctx.reply.split(',').includes(String(indexChildren + 1)) ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true), !_ctx.answer.split(',').includes(String(indexChildren + 1)) ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.alphabet[indexChildren]) + "." + _toDisplayString(_ctx.options[indexChildren].answerName), 1)]);
  }), 128)) : _createCommentVNode("", true), _ctx.type == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_ctx.options.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_ctx.answer == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25)) : _createCommentVNode("", true), _ctx.answer != '0' && _ctx.reply == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28)) : _createCommentVNode("", true), _ctx.answer != '0' && !_ctx.reply || _ctx.reply == '1' && _ctx.answer == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31)) : _createCommentVNode("", true), _hoisted_32])) : _createCommentVNode("", true), _ctx.options.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_ctx.answer == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36)) : _createCommentVNode("", true), _ctx.answer != '1' && _ctx.reply == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39)) : _createCommentVNode("", true), _ctx.answer != '1' && !_ctx.reply || _ctx.reply == '0' && _ctx.answer == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42)) : _createCommentVNode("", true), _hoisted_43])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
}